import directus from '@/plugins/directusSdk'
import errorDirectus from '@/lib/Error/directus'

export default {
  async getItems ({ state, commit, dispatch }) {
    try {
      let fields = state.fields.split(',')
      if (state.fields === '') {
        fields = ['*']
      }

      const { data } = await directus.getItems(state.collection, {
        fields
      })
      commit('setAttr', {
        name: 'models',
        value: data
      })
    } catch (err) {
      errorDirectus(err, dispatch)
    }
  }
}
